
import * as ipxRuntime$_1I5YhTErR3af014oFsJXi_452MrdQdEtfAAq1ddFpEWKk from '/usr/src/nuxt-app/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['ipx']: { provider: ipxRuntime$_1I5YhTErR3af014oFsJXi_452MrdQdEtfAAq1ddFpEWKk, defaults: {} }
}
        